module.exports = __webpack_public_path__ + "static/aersa-logo-3c7c22d3c9aa133927960033baa6e018.svg";